import React from "react";
import { Box, Typography } from "@mui/material";
import { ArrowDown, ArrowUp } from "react-bootstrap-icons";

const ProfitChangeCard = ({ riseFallPercentage }) => {
  const isPositive = riseFallPercentage > 0;
  const hasData =
    riseFallPercentage !== null && riseFallPercentage !== undefined;

  if (!hasData) {
    return (
      <Box
        sx={{
          background: "white",
          padding: "24px",
          display: "flex",
          width: {xs: "100%",md:"240px"},
          textAlign: "center",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "16px",
        }}
      >
        <Typography variant="body1">لا يوجد بيانات في الشهر السابق</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        background: "white",
        padding: "24px",
        display: "flex",
        width: { xs: "100%", md: "240px" },
        textAlign: "left",
        gap: "8px",
        borderRadius: "16px",
      }}
    >
      <Box
        sx={{
          width: "fit-content",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {isPositive ? <ArrowUp size={36} /> : <ArrowDown size={36} />}
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Typography variant="h5" fontWeight={600}>
          {Math.abs(Number(riseFallPercentage)).toFixed(1)}%
        </Typography>
        <Typography fontSize={12}>
          {isPositive
            ? "ارتفاع الأرباح بالنسبة للشهر السابق"
            : "إنخفاض الأرباح بالنسبة للشهر السابق"}
        </Typography>
      </Box>
    </Box>
  );
};

export default ProfitChangeCard;
